__turbopack_context__.v({
  "container": "M-dpuq_container",
  "size--lg": "M-dpuq_size--lg",
});
